import { render, staticRenderFns } from "./D004.vue?vue&type=template&id=395ed06a&scoped=true&"
import script from "./D004.vue?vue&type=script&lang=js&"
export * from "./D004.vue?vue&type=script&lang=js&"
import style0 from "./D004.vue?vue&type=style&index=0&id=395ed06a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395ed06a",
  null
  
)

export default component.exports